import { render } from "./EnOverlayBadge.vue?vue&type=template&id=2a09ca94&ts=true"
import script from "./EnOverlayBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnOverlayBadge.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/badge/EnOverlayBadge/EnOverlayBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a09ca94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a09ca94', __exports__)) {
    api.reload('2a09ca94', __exports__)
  }
  
  module.hot.accept("./EnOverlayBadge.vue?vue&type=template&id=2a09ca94&ts=true", () => {
    api.rerender('2a09ca94', render)
  })

}


export default __exports__